import React from "react"
import {Routes, Route} from "react-router-dom"

import {SequencingPage} from "./SequencingPage"

export const TemplateSequences = () => {
	return (
		<Routes>
			<Route path="/" element={<SequencingPage />} />
		</Routes>
	)
}
